import axiosInstance from "api/axiosInstance";

import type { PracticeReservation, PracticeReservationAdminCancelRequest, PracticeReservationListParams } from "api/types/practice-reservations.types";

const BASE = "/server/buccl_lessons/api/v1/practice-reservations/";

export const practiceReservationsService = {
  list: (params?: PracticeReservationListParams) => axiosInstance.get<PracticeReservation[]>(BASE, { params }),

  get: (id: number) => axiosInstance.get<PracticeReservation>(`${BASE}${id}/`),

  paymentComplete: (reservationId: number) => axiosInstance.post(`${BASE}${reservationId}/payment/complete/`),

  paymentReject: (reservationId: number, reason?: string) => axiosInstance.post(`${BASE}${reservationId}/payment/reject/`, { reason }),

  // 관리자·소유 강사: 예약 강제 취소 (reservationId = PracticeReservation.id)
  adminCancel: (reservationId: number, payload?: PracticeReservationAdminCancelRequest) => axiosInstance.post(`${BASE}${reservationId}/admin-cancel/`, payload ?? {}),
};
